var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxGerman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "German flag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Language-selection-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-16.000000, -416.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-german",
    transform: "translate(16.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,13.4024228 23.7594335,14.7488894 23.3172564,16 L0.682816275,16 C0.240624601,14.7488894 0,13.4024228 0,12 C0,10.5975627 0.240624601,9.2510961 0.682816275,8 L23.3172564,8 C23.7594335,9.2510961 24,10.5975627 24,12",
    id: "Fill-3",
    fill: "#DE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3684211,16 C21.7137791,20.6607192 17.2484945,24 11.9999854,24 C6.75141792,24 2.2862355,20.6607192 0.631578947,16 L23.3684211,16",
    id: "Fill-4",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3684211,8 L0.631578947,8 C2.2862355,3.33932926 6.75141792,0 11.9999854,0 C17.2484945,0 21.7137791,3.33932926 23.3684211,8",
    id: "Fill-5",
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxGerman);
export default __webpack_public_path__ + "static/media/px-german.cd4101e9d487f877ced9bf68b1bde2b8.svg";
export { ForwardRef as ReactComponent };